import React from "react";
import Subheader from "material-ui/Subheader";

export default class CustomSubheader extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const { style = {}, inset = false } = this.props;
        return <Subheader {...this.props} style={Object.assign({}, style)} inset={inset} />;
    }
}
